// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__f9J95","header":"MergedInvoice_header__11crf"};